<template>
	<div ref="contentContainer" class="rich-text" v-html="htmlWithGlossary" />
	<MaoAlert background="var(--surface-secondary-container)" color="var(--text-on-secondary-container)" :title="word" :status="alertStatus" @close="closeAlert">
		<p class="body-small" style="color: var(--text-on-secondary-container)" v-html="currentDefinition" />
	</MaoAlert>
</template>

<script>
import { useAppDataStore } from '@/stores/appData'
import MaoAlert from './MaoAlert.vue'
import DOMPurify from 'dompurify'

export default {
	components: {
		MaoAlert
	},
	props: {
		content: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			alertStatus: false,
			currentDefinition: '',
			appDataStore: useAppDataStore(),
		}
	},
	computed: {
		htmlWithGlossary() {
			if (!this.content) {
				return ''
			}
			let htmlString = this.content
			this.appDataStore.appData.glossary.forEach(({ word }) => {
				const regexExpression = new RegExp(`\\b(${word})\\b`, 'gi')
				htmlString = htmlString.replace(
					regexExpression,
					'<span class="special-word" data-word="$1">$1</span>'
				)
			})
			return DOMPurify.sanitize(htmlString)
		},
		word() {
			let word = this.appDataStore.appData.glossary.filter(({ word }) => {
				const regexExpression = new RegExp(`\\b(${word})\\b`, 'gi')
				if (this.content.match(regexExpression)) {
					return word;
				}
			});
			// if word first letter uppercase, otherwise if word doesn't exist, return empty string
			if (word.length > 0) {
				return word[0].word.charAt(0).toUpperCase() + word[0].word.slice(1);
			} else {
				return '';
			}
		}
	},
	mounted() {
		this.$refs.contentContainer.addEventListener(
			'click',
			this.openAlertFromEvent
		)
	},
	beforeUnmount() {
		this.$refs.contentContainer.removeEventListener(
			'click',
			this.openAlertFromEvent
		)
	},
	methods: {
		openAlertFromEvent(event) {
			const element = event.target.closest('.special-word');
			if (!element) {
				return
			}
			const glossaryWord = element.dataset.word;
			this.word = glossaryWord;
			const glossaryEntry = this.appDataStore.appData.glossary.find(
				term => term.word.toLowerCase() === glossaryWord.toLowerCase()
			)
			if (glossaryEntry) {
				this.currentDefinition = glossaryEntry.description
				this.alertStatus = true
			}
		},
		closeAlert() {
			this.alertStatus = false
			this.currentDefinition = ''
		}
	}
}
</script>

<style lang="scss">
.special-word {
	text-decoration: underline;
	cursor: pointer;
	text-decoration-thickness: 0.1rem;
	text-underline-offset: 0.2rem;
}

.rich-text p {
	margin: 0 0 1rem;
}

.rich-text a {
	color: white;
}
</style>
